import React from 'react';
import { useTheme } from '@mui/material/styles';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { Trans } from '@gamiphy/react-i18n';
import Gift from '@gamiphy/icons/Gift';
import Star from '@gamiphy/icons/Star';
import { AppCashbackStore } from '@gamiphy/loyalty-station-desktop/store/appCashback';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import compact from 'lodash/compact';
import { formatCashbackPromotionValue } from '../../utils';

export const useBenefits = (): { text: React.ReactNode, icon: React.ReactNode }[] => {
  const theme = useTheme();
  return React.useMemo(() => (compact([
    AppCashbackStore.currentAppCashback?.enabled && {
      icon: <Gift color={theme.palette.primary.main} />,
      text: AppStore.app.agent === 'wake' ? (
        <Trans
          i18nKey="coreloyalty.cashback.benefits.cashback.predefinedPromotions"
          defaults="An amazing up to {{promotionValue}} cashback on all your purchases"
          values={{
            promotionValue: AppCashbackStore.highestPromotionAppCashback && formatCashbackPromotionValue(AppCashbackStore.highestPromotionAppCashback),
          }}
        />
      ) : (
        <Trans
          i18nKey="coreloyalty.cashback.benefits.cashback"
          defaults="An amazing {{cashbackPercentage}}% cashback on every purchase"
          values={{
            cashbackPercentage: AppCashbackStore.defaultAppCashback?.percentage,
          }}
        />
      ),
    },
    LevelStore.tierConfig?.enabled &&
    {
      icon: <Star color={theme.palette.primary.main} />,
      text: <Trans
        i18nKey="coreloyalty.cashback.benefits.vip"
        defaults="Become a VIP member and unlock more exciting rewards"
      />,
    },
  ])), [
    AppStore.app,
    AppCashbackStore.highestPromotionAppCashback,
    AppCashbackStore.defaultAppCashback,
    AppWelcomeGiftStore.welcomeGift,
    LevelStore.tierConfig,
    theme,
  ]);
};
